import { useCallback } from 'react';

import { httpsCallable } from 'firebase/functions';

import { logError } from '../analytics/analytics';
import { cloudFunctions } from '../firebase';

// Emails a fresh invitation link to an invitee who reached Gratigolf without it.
// The function responds the same whether or not an invitation exists, so true only means the request went through.
export function useRequestInviteByEmail() {
  const requestInviteByEmail = useCallback(async (email: string): Promise<boolean> => {
    try {
      await httpsCallable(cloudFunctions, 'requestInviteByEmail')({ email });
      return true;
    } catch (error) {
      logError('request_invite_by_email', error);
      return false;
    }
  }, []);

  return { requestInviteByEmail };
}
